'use strict';

import { IRootScopeService, IScope } from "angular";
import { EQueueEntryState, QueueEntryResponse, UpdateQueuePriorityRequest, UpdateQueueStateRequest } from "../../../../data/queue.data";

import RestService from "../../../../services/rest.service";
import * as L from "leaflet";
import MapService from "../../../../services/map.service";
import PrivilegeService from "../../../../services/privilege.service";
import {RolePrivilege} from "../../../../data/privileges.enum";

'use strict';

import angular = require("angular");

require('./queue.entry.scss');

export default class QueueEntryComponent {
  public restrict: string;
  public scope;
  public template;
  public controller;
  public controllerAs: string;
  public bindToController: boolean;
  constructor() {
    this.restrict = 'EA'
    this.scope = {
      entry: '=',
      qact: '='
    }
    this.template = require('./queue.entry.html');

    this.controller = QueueEntryComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}

class QueueEntryComponentController {
  private entry: QueueEntryResponse;
  private listeners = [];
  private expanded: boolean = false;
  private highlighted: boolean = false;
  private hasQueueEdit: boolean= false;

  public marker: L.Marker;
  public map;

  constructor(public $scope: IScope, public $rootScope: IRootScopeService, public mapService: MapService, public restService: RestService, private privilegeService:PrivilegeService) {
    this.hasQueueEdit = privilegeService.has(RolePrivilege.Alarm_Queues_Edit);
    this.initListeners();
  }


  initListeners() {
    this.listeners.push(this.$scope.$watch('ctrl.entry', (oldValue, newValue) => {
      if (newValue) {
        this.listeners.push(this.$rootScope.$on(`queue.${this.entry.queueId}.update.state`, (event, queueResponse) => {
          this.entry.queueActive = queueResponse.active;
        }));

      }
    }));
    // Highlight element if there is an hover event
    this.listeners.push(this.$rootScope.$on('queue.entry.mouse.enter', (event, queueResponse: QueueEntryResponse) => {
      if (this.entry.id === queueResponse.id) return;
      this.highlighted = this.entry.externalId === queueResponse.externalId;
    }));
    this.listeners.push(this.$rootScope.$on('queue.entry.mouse.leave', (event, queueResponse) => {
      if (this.highlighted) {
        this.highlighted = false;
      }
    }));

    this.$scope.$on('$destroy', () => {
      this.listeners.forEach((listener) => {
        listener();
      });
    });
  }

  priorityUp($event) {
    $event.stopPropagation();

    if (this.entry.state === EQueueEntryState.DONE) return;

    if (this.entry.priority === 4) {
      this.entry.priority = 1;
    } else {
      this.entry.priority++;
    }
    this.changePriority(this.entry.priority);
  }

  changePriority(newPriority: number): void {
    this.restService.updateQueueEntryPriority(this.entry.id, {
      priority: newPriority
    } as UpdateQueuePriorityRequest).then(result => {
      this.entry.priority = result.priority;
    }).finally(() => {
      this.$scope.$applyAsync();
    });
  }

  mouseEnter(): void {
    this.$rootScope.$emit('queue.entry.mouse.enter', this.entry);
  };

  mouseLeave(): void {
    this.$rootScope.$emit('queue.entry.mouse.leave', this.entry);
  }

  assign(): void {
    if (!this.entry.queueActive || !this.hasQueueEdit) return;
    this.restService.updateQueueEntryState(this.entry.id, {
      state: EQueueEntryState.IN_PROGRESS,
      queueId: this.entry.queueId
    } as UpdateQueueStateRequest);
  }

  done(mode: EFinishMode): void {
    this.restService.updateQueueEntryState(this.entry.id, {
      state: EQueueEntryState.DONE,
      finishMode: mode,
      queueId: this.entry.queueId
    } as UpdateQueueStateRequest);
  }

  expand(): void {
    if (this.entry.state === EQueueEntryState.ASSIGNED) return;
    if (!this.expanded) {
      // Show
      this.expanded = true;
      if (this.entry.hasMap) {
        // Wait a little bit after div is displayed
        setTimeout(() => {
          this.initMap();
        }, 500);
      }
    } else {
      // Hide
      let doc = document.getElementById(`${this.entry.id}_expansion`);
      doc.classList.add('swing-out-top-bck');
      setTimeout(() => {
        this.expanded = false;
        this.$scope.$applyAsync();
      }, 500);
    }
  }

  initMap() {
    L.Icon.Default.imagePath = '/img/static';
    const latLng = L.latLng(this.entry.alarmData.parameters['lat'], this.entry.alarmData.parameters['lng']);

    this.map = L.map(`${this.entry.id}_map`, { attributionControl: false, zoomControl: false }).setView(latLng, 13);
    let layers = this.mapService.getBaseLayers();
    let selectedLayer = this.mapService.getSelectedLayer();
    if (selectedLayer == undefined || layers[selectedLayer] == undefined) {
      selectedLayer = "OpenStreetMap";
    }
    layers[selectedLayer].addTo(this.map);
    this.marker = L.marker(latLng, { draggable: false }).addTo(this.map);
  }


  /**
   * Remove hover css class to avoid weird hover effects
   */
  onMouseEnter($event): void {
    angular.element($event.target).parent().removeClass('queue-entry-hover');
  }

  /**
   * Add hover css again to parent
   */
  onMouseLeave($event): void {
    if (this.entry.state !== EQueueEntryState.ASSIGNED) return;
    angular.element($event.target).parent().addClass('queue-entry-hover');
  }
}

enum EFinishMode {
  FINISH_SINGLE_ENTRY = 'FINISH_SINGLE_ENTRY', FINISH_ALL_ENTRIES = 'FINISH_ALL_ENTRIES'
}
